// ** React Imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppConfiguration } from "@src/redux/app";

export const useApp = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const appInfo = useSelector((state) => state.app.appInfo);

  const setAppInfo = appInfo => {

    dispatch(setAppConfiguration({
      config: appInfo
      }));
  };

  return { appInfo, setAppInfo };
};
